import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 项目样式初始化
import '@/styles/init.css'
import '@/styles/font.scss'
import '@/styles/variables.scss'
import '@/styles/theme.scss'

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')

